import PropTypes from "prop-types";
import React, { Fragment } from "react";
import ShopTopAction from "./ShopTopAction";

const ShopTopbar = ({
  toggleFilterbar,
                 FilterOpen,
  getLayout,
  getFilterSortParams,
  productCount,
  sortedProductCount,
  selectProduct,
  products,
  selectAll,
  productsLength,
  setProductsLength,
  selectCheckbox,
  setSelectCheckbox,
}) => {
  return (
    <Fragment>
      {/* shop top action */}
      <ShopTopAction
      toggleFilterbar={toggleFilterbar}
                 FilterOpen={FilterOpen}
        products={products}
        selectAll={selectAll}
        getLayout={getLayout}
        getFilterSortParams={getFilterSortParams}
        productCount={productCount}
        sortedProductCount={sortedProductCount}
        selectProduct={selectProduct}
        productsLength={productsLength}
        setProductsLength={setProductsLength}
        selectCheckbox={selectCheckbox}
        setSelectCheckbox={setSelectCheckbox}
      />
    </Fragment>
  );
};

ShopTopbar.propTypes = {
  getFilterSortParams: PropTypes.func,
  getLayout: PropTypes.func,
  productCount: PropTypes.number,
  sortedProductCount: PropTypes.number,
};

export default ShopTopbar;
